(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/store/redux.js');
"use strict";

var _svs$spelpaus$data;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$spelpaus$store$s = svs.spelpaus.store.suspension,
  reducer = _svs$spelpaus$store$s.reducer,
  initialState = _svs$spelpaus$store$s.initialState;
const reducerObject = {
  suspension: reducer
};

svs.spelpaus.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};

const suspensionPreloadedRawData = ((_svs$spelpaus$data = svs.spelpaus.data) === null || _svs$spelpaus$data === void 0 ? void 0 : _svs$spelpaus$data.preloadedState) || null;

const totalSuspensionState = _objectSpread(_objectSpread({}, initialState), suspensionPreloadedRawData);

const store = svs.spelpaus.store.createStore({
  suspension: totalSuspensionState
});
const SuspensionReduxProvider = _ref => {
  let children = _ref.children;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.spelpaus.store.SuspensionReduxProvider = SuspensionReduxProvider;

 })(window);